import Vue from 'vue';
import {
  BootstrapVue, ToastPlugin, ModalPlugin, IconsPlugin,
} from 'bootstrap-vue';
import axios from 'axios';
import VueGoodTablePlugin from 'vue-good-table';
import vSelect from 'vue-select';
import ToggleButton from 'vue-js-toggle-button';
import Notifications from 'vue-notification';
import VueI18n from 'vue-i18n';
import VuePhoneNumberInput from 'vue-phone-number-input';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import VueFileAgent from 'vue-file-agent';
import vClickOutside from 'v-click-outside';
import AOS from 'aos';
import 'aos/dist/aos.css';
import VueApexCharts from 'vue-apexcharts';
import App from './App.vue';
import router from './router';
import store from './store';
import en from './i18n/en.json';
import sq from './i18n/sq.json';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import 'vue-file-agent/dist/vue-file-agent.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'vue-good-table/dist/vue-good-table.css';
import 'vue-select/dist/vue-select.css';
import RequestLoading from './mixins/RequestLoading';
import LoadingSpinnerTable from './components/LoadingSpinnerTable.vue';
import LoadingWrapperSpinner from './components/LoadingWrapperSpinner.vue';
import connection from './microsoft-signalR/signalR';

// Register the libraries and plugins
Vue.use(VueApexCharts);
Vue.use(vClickOutside);
Vue.component('apexchart', VueApexCharts);
library.add(faArrowRightFromBracket);

axios.interceptors.request.use((config) => {
  const _token = store.state.authentication.loggedInUser.token;
  if (_token) config.headers.Authorization = `Bearer ${_token}`;
  return config;
});

axios.interceptors.response.use(
  (response) => { return response },
  (error) => { return Promise.reject(error) },
);

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: store.state.authentication.language,
  silentTranslationWarn: true,
  fallbackLocale: 'en',
  messages: {
    en,
    sq,
  },
});

Vue.mixin(RequestLoading);
Vue.use(VueFileAgent);
Vue.use(BootstrapVue);
Vue.use(ToggleButton);
Vue.use(Notifications);
Vue.component('LoadingSpinnerTable', LoadingSpinnerTable);
Vue.component('LoadingWrapperSpinner', LoadingWrapperSpinner);
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Register BootstrapVue with specific configurations
Vue.use(BootstrapVue, {
  BDropdown: {
    popperOpts: {
      positionFixed: true,
    },
    boundary: 'window',
  },
  BFormInput: {
    autocomplete: 'off',
  },
  BInput: {
    autocomplete: 'off',
  },
});

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);
Vue.use(IconsPlugin);
Vue.use(VueGoodTablePlugin);
Vue.component('vue-select', vSelect);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);

// Import your styles
require('@/assets/scss/style.scss');

Vue.mixin({
  mounted() {
    if (this.$options.name === 'BModal') {
      this.$nextTick(() => {
        if (!this.$props.scrollable) {
          this.$set(this.$props, 'scrollable', true);
        }
      });
    }
  },
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  connection,
  mounted() {
    AOS.init();
  },
  render: (h) => { return h(App) },
}).$mount('#app');
